/**
 * Stable CSS class names for E2E — Membership SMS management.
 */
export const MSM = {
    page: 'membership-sms-management-page',
    breadcrumbSection: 'membership-sms-management-page__breadcrumb-section',

    filterGate: 'membership-sms-management-page__filter-gate',
    filterGateCountryField: 'membership-sms-management-page__filter-country-field',
    inputSelectCountry: 'membership-sms-management-page-input--select-country',
    filterGatePlatformField: 'membership-sms-management-page__filter-platform-field',
    inputSelectPlatform: 'membership-sms-management-page-input--select-platform',
    inputButtonFilter: 'membership-sms-management-page-input--button-filter',

    filteredShell: 'membership-sms-management-page__filtered-shell',
    tabsWrap: 'membership-sms-management-page__tabs-wrap',
    tabsRoot: 'membership-sms-management-page__tabs',
    tabMembershipSms: 'membership-sms-management-page-input--tab-membership-sms',
    tabUpdateHistory: 'membership-sms-management-page-input--tab-update-history',
    tabPanelWrap: 'membership-sms-management-page__tab-panel-wrap',

    membershipTabRoot: 'membership-sms-management-membership-tab',
    membershipTabTableWrap: 'membership-sms-management-membership-tab__table-wrap',
    membershipTabAccordion: 'membership-sms-management-membership-tab__accordion',
    membershipTabAccordionDetails: 'membership-sms-management-membership-tab__accordion-details',
    membershipTabRateToolbar: 'membership-sms-management-membership-tab__rate-toolbar',
    membershipTabHourGrid: 'membership-sms-management-membership-tab__hour-grid',
    membershipTabHourCell: 'membership-sms-management-membership-tab__hour-cell',
    inputButtonCancelEdit: 'membership-sms-management-membership-tab-input--button-cancel-edit',
    inputButtonSaveOrEdit: 'membership-sms-management-membership-tab-input--button-save-or-edit',
    inputTextHourLimit: 'membership-sms-management-membership-tab-input--text-hour-limit',

    updateHistoryTabRoot: 'membership-sms-management-update-history-tab',
    updateHistoryToolbar: 'membership-sms-management-update-history-tab__toolbar',
    updateHistoryDateRangeWrap: 'membership-sms-management-update-history-tab__date-range-wrap',
    updateHistoryTableWrap: 'membership-sms-management-update-history-tab__table-wrap',
    updateHistoryAccordion: 'membership-sms-management-update-history-tab__accordion',
    updateHistoryAccordionDetails: 'membership-sms-management-update-history-tab__accordion-details',
    updateHistoryHourGrid: 'membership-sms-management-update-history-tab__hour-grid',
    updateHistoryHourBlock: 'membership-sms-management-update-history-tab__hour-block',
} as const;

export const msmCls = (...parts: Array<string | undefined | false>) => parts.filter(Boolean).join(' ');
